import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";

const Layout = () => {
  return (
    <div className="flex min-h-screen bg-[#f4f5f7]">
      <Sidebar />
      <main className="flex-1 min-w-0 px-5 md:px-8 py-6 overflow-x-hidden">
        <div className="max-w-[1500px] mx-auto">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default Layout;
